module.exports = __webpack_public_path__ + "static/img/em.a7d4fc7d.png";